<template>
  <div
    class="smartcollection-header"
    :style="{ background: background }"
  >
    <div
      class="d-flex align-items-center"
    >
      <div class="w-100">
        <h1>{{ collection.title }}</h1>
        <p v-if="collection.subheader">
          {{ collection.subheader }}
        </p>
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="collection.description"
          class="collection-body"
          :class="{ show: showingDescription }"
          v-html="collection.description"
        />
        <!-- eslint-enable vue/no-v-html -->
        <div
          v-if="collection.description"
          :class="{ 'show-full-description': true, show: showingDescription }"
          @click="toggleDescription"
          @keypress="toggleDescription"
        >
          Read {{ showingDescription ? 'Less' : 'More' }}
          <img
            v-if="showingDescription"
            :src="up"
            alt=""
          >
          <img
            v-if="!showingDescription"
            :src="down"
            alt=""
          >
        </div>
      </div>
      <img
        v-if="collection.header_image"
        class="d-lg-block d-none header-bg pl-3"
        :src="collection.header_image"
        alt=""
      >
    </div>
  </div>
</template>
<script>
import DownChevron from '~/static/down-chevron.svg';
import UpChevron from '~/static/up-chevron.svg';
import { lightenColor } from '~/util/global';

export default {
  props: {
    collection: {
      type: Object,
      required: true,
    },
    isWishlist: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showingDescription: false,
    };
  },
  computed: {
    up() { return UpChevron; },
    down() { return DownChevron; },
    background() {
      if (this.collection.header_background) {
        const dk = this.collection.header_background.replace('#', '');
        const lt = lightenColor(dk, 25);
        return `radial-gradient(58.66% 71.5% at 64.93% 27.87%, #${lt} 24.72%, #${dk} 100%)`;
      }

      return null;
    },
  },
  methods: {
    toggleDescription() {
      this.showingDescription = !this.showingDescription;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~/styles/utils/breakpoints';

.smartcollection-header {
  background: radial-gradient(58.66% 71.5% at 64.93% 27.87%, #265e60 24.72%, #09292b 100%);
  border-radius: 4px;
  width: 100%;
  padding: 24px 32px 32px;
  margin-bottom: 32px;
  display: flex;
}

.smartcollection-header > div:first-child {
  flex-grow: 1;
}

.smartcollection-header .show-full-description {
  display: none;
}

.smartcollection-header .show-full-description svg path {
  fill: #fff;
}

.smartcollection-header h1 {
  font-weight: 700;
  font-size: 32px;
  line-height: 48px;
  color: #fff;
}

.smartcollection-header h3 {
  font-weight: 700;
  font-size: 32px;
  line-height: 48px;
  color: #fff;
}

.smartcollection-header .collection-body,
.smartcollection-header h5 {
  font-weight: 400;
  color: #fff;
}

.smartcollection-header h5 {
  font-size: 18px;
  line-height: 27px;
  margin-bottom: 8px;
}

.smartcollection-header p {
  font-weight: 400;
  color: #fff;
  font-size: 18px;
  line-height: 27px;
  margin-bottom: 8px;
}

.smartcollection-header .collection-body {
  font-size: 16px;
  line-height: 24px;
  margin-top: 8px;
}

.smartcollection-header .collection-body a,
.smartcollection-header .collection-body a:visited {
  color: #fff;
  text-decoration: underline;
}

.smartcollection-header .collection-body p:last-child {
  margin-bottom: 0;
}

.smartcollection-header .header-bg {
  height: 180px;
  width: auto;
  margin: -16px 0;
}

@include media-breakpoint-down(sm) {
  .smartcollection-header {
    margin-bottom: 24px;
    padding: 16px;
  }

  .smartcollection-header h1 {
    font-size: 24px;
    line-height: 32px;
  }

  .smartcollection-header h3 {
    font-size: 24px;
    line-height: 32px;
  }

  .smartcollection-header .show-full-description {
    display: block;
    color: #fff;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
    padding: 10px 30px;
    text-align: center;
    cursor: pointer;
    margin-bottom: -16px;
    margin-left: -30px;
    margin-right: -30px;
  }

  .smartcollection-header .collection-body {
    display: none;
  }

  .smartcollection-header .collection-body.show {
    display: block;
    margin-bottom: 16px;
  }
}
</style>
